import { __awaiter } from "tslib";
import ajaxUtils from './ajaxUtils';
export const refreshContactData = (refreshPayload) => __awaiter(void 0, void 0, void 0, function* () { return ajaxUtils.patch('/api/v1/revealed-contacts/snapshot', refreshPayload); });
